module.exports = __webpack_public_path__ + "img/home3.32eb5e44.jpg";